<template>
    <modal title-modal="Loteamentos da Configuração" modal-large id-modal="config-simulator-allotments-modal">
        <template #title>Loteamentos da Configuração</template>

        <div class="modal-body">
            <div class="form-group">
                <label for="config_simulator_allotment_ids">Loteamentos vinculados:</label>
                <select2 id="config_simulator_allotment_ids"
                         :settings="selectSettings"
                         :options="allotments"
                         :disabled="disableInputs"
                         v-model="selectedAllotmentIds"/>
            </div>
            <small class="text-muted">
                Selecione os loteamentos que devem usar esta configuração de simulador.
            </small>
        </div>

        <div class="modal-footer" style="justify-content: space-between">
            <div class="btn btn-secondary" data-dismiss="modal" id="closeConfigSimulatorAllotments">
                {{ t('ACTIONS.CLOSE') }}
            </div>
            <div class="btn btn-primary ml-2" v-if="!disableInputs" @click="save">
                {{ t('ACTIONS.SAVE') }}
            </div>
        </div>
    </modal>
</template>

<script>

import {useI18n} from 'vue-i18n';
import modal from '@/components/modal.vue';
import Select2 from 'vue3-select2-component';
import Validate from '@/components/validate.vue';
import Allotments from '@/services/Allotments';

export default {
    name: 'configSimulatorAllotmentsComponent',

    mixins: [Validate],

    components: {
        modal,
        Select2,
    },

    props: {
        disableInputs: {
            type: Boolean,
            default: false,
        },
    },

    emits: ['updateAllotments'],

    setup() {
        const {t} = useI18n();
        return {t};
    },

    data() {
        return {
            allotments: [],
            selectedAllotmentIds: [],
            selectSettings: {
                width: '100%',
                multiple: true,
                dropdownParent: '#config-simulator-allotments-modal',
            },
        };
    },

    methods: {
        setAllotments(simulatorConfig) {
            this.selectedAllotmentIds = (simulatorConfig.allotments ?? []).map(({id}) => id);
            this.loadAllotments();
        },

        loadAllotments() {
            if (this.allotments.length > 0) return;

            this.$store.commit('changeLoading', true);
            Allotments.listWithoutBoolean()
                .then(resp => this.allotments = resp.data)
                .catch(err => this.errorMsg(err))
                .finally(() => this.$store.commit('changeLoading', false));
        },

        closeModal() {
            document.getElementById('closeConfigSimulatorAllotments')?.click();
        },

        save() {
            this.$swal.fire({
                title: 'Tem Certeza?',
                text: 'A alteração será aplicada imediatamente.',
                icon: 'question',
                showCancelButton: true,
                showCloseButton: false,
                confirmButtonText: 'Atualizar',
                cancelButtonText: 'Cancelar',
            }).then(result => {
                if (result.isConfirmed) this.$emit('updateAllotments', this.selectedAllotmentIds ?? []);
            });
        },
    },
};

</script>
